import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {Toggle} from '@vio/atlas/Toggle'
import {Tooltip, TooltipPlacement} from '@vio/atlas/Tooltip'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

interface Props {
  checked: boolean
  onChange: () => void
  totalPriceMessage: React.ReactNode
}
export const TotalPriceToggleDesktop: React.FC<Props> = ({
  checked,
  onChange,
  totalPriceMessage
}) => {
  return (
    <Box display="flex" marginLeft="auto" gap="s200">
      <Box
        display="flex"
        cursor="pointer"
        alignItems="center"
        gap="s100"
        onClick={onChange}
      >
        <Text variant="bodyS" id="showTotalPrice">
          <FormattedMessageWrapper
            id="showTotalPrice"
            defaultMessage="Show total price"
          />
        </Text>
        <Tooltip
          placement={TooltipPlacement.BottomStart}
          content={<Text variant="bodyS">{totalPriceMessage}</Text>}
        >
          <Icon
            name="Information"
            size={'sm'}
            colorPath="content.neutral.secondary"
          />
        </Tooltip>
      </Box>
      <Toggle
        id="totalPriceToggle"
        checked={checked}
        onChange={onChange}
        ariaLabelledBy="showTotalPrice"
      />
    </Box>
  )
}
